import React from "react";

const OrderTotal = ({ totalprice, length }) => {
	return (
		<section className='sm:w-1/3 bg-white py-3 px-5'>
			<div className='py-3 border-b-2'>
				<h1 className='uppercase text-lg text-gray-400'>Price Details</h1>
			</div>
			<div>
				<div className='flex justify-between py-2 text-gray-700'>
					<h1>{`Price ( ${length} )`}</h1>
					<p>{totalprice}</p>
				</div>
				<div className='flex justify-between py-2 text-gray-700'>
					<h1>Discount</h1>
					<p className=' text-custom-green'>−₹807</p>
				</div>
				<div className='flex justify-between py-2 text-gray-700'>
					<h1>Delivery Charges</h1>
					<p className='text-custom-green'>FREE</p>
				</div>
			</div>
			<div className='flex justify-between py-4  border-t-2 border-b-2 text-lg font-bold'>
				<h1>Total Amount</h1>
				<p>{totalprice - 807}</p>
			</div>
			<div className='py-2'>
				<p className='text-custom-green'>You will save ₹807 on this order</p>
			</div>
		</section>
	);
};

export default OrderTotal;
